import Box from '@mui/material/Box';
import { Loader } from '@/components/atoms/Loader/Loader';

interface LoadingProps {
  className?: string;
}

export const Loading = ({ className }: LoadingProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Loader className={className} />
    </Box>
  );
};

Loading.displayName = 'Loading';

export default Loading;
